import { GetAccountInfoQuery } from '@websky/graphql';
import * as React from 'react';
import { useCallback, useState } from 'react';
import { reachGoal, UserGoal } from '../../../../../analytics';
import { LoginFormModal } from '../../../../../LoginPage';

interface Props {
	userInfo?: GetAccountInfoQuery['CurrentUser'];
	refetchUser?: () => Promise<GetAccountInfoQuery>;
	children: (params: {
		openLogin: (preselectedLogin: string) => void;
		userInfo: GetAccountInfoQuery['CurrentUser'];
		refetchUser: () => Promise<GetAccountInfoQuery>;
		isLoginFormOpen: boolean;
	}) => React.ReactNode;
}

const Login: React.FC<Props> = props => {
	const [isLoginPageOpened, setLoginPageOpened] = useState(false);
	const [preselectedLogin, setPreselectedLogin] = React.useState('');

	const onOpenLogin = (preselectedLogin: string) => {
		setPreselectedLogin(preselectedLogin);
		setLoginPageOpened(true);
	};

	const onSuccessfulLogin = useCallback(
		(isRegistration = false) => {
			setLoginPageOpened(false);

			reachGoal(isRegistration ? UserGoal.Registration : UserGoal.Login);

			if (props.refetchUser) {
				props.refetchUser();
			}
		},
		[props.refetchUser]
	);

	return (
		<>
			<LoginFormModal
				modalProps={{
					isOpen: isLoginPageOpened,
					onClose: () => setLoginPageOpened(false)
				}}
				loginFormProps={{
					login: preselectedLogin,
					onSuccess: onSuccessfulLogin
				}}
			/>

			{props.children({
				openLogin: onOpenLogin,
				userInfo: props.userInfo,
				refetchUser: props.refetchUser,
				isLoginFormOpen: isLoginPageOpened
			})}
		</>
	);
};

export default Login;
